<div class="loading-spinner-container">
  <mat-progress-spinner *ngIf="loading$ | async"
    [mode]="'indeterminate'" diameter="120"></mat-progress-spinner>
</div>
